import SiteLoading from '@/src/components/Wrapper/SiteLoading';
import { GEMINI_URL } from '@/src/constants/endpoints';
import { EOC1_REDIRECT } from '@/src/constants/feature-flags';
import { ROUTE_RENEWAL_EOC } from '@/src/constants/routes';
import { useFeature } from '@/src/utils/optimizely';
import { useAccountContext, useCustomerContext } from '@ovotech/ui-tools';
import React from 'react';
import { useLocation } from 'react-router-dom-v5';

export function Renewal() {
  const { accountId } = useAccountContext();
  const { customerId } = useCustomerContext();
  const [isRedirectEoc1] = useFeature(EOC1_REDIRECT);
  const location = useLocation();

  if (!accountId || !customerId) {
    return <SiteLoading />;
  } else {
    const urlParams = new URLSearchParams(location.search);
    urlParams.set('accountId', accountId);
    urlParams.set('customerId', customerId);
    const queryString = urlParams.toString();

    const geminiUrl =
      ROUTE_RENEWAL_EOC === location.pathname
        ? isRedirectEoc1
          ? `${GEMINI_URL}/energy-renewal/end-of-contract-options?${queryString}`
          : undefined
        : `${GEMINI_URL}/energy-renewal?${queryString}`;

    if (geminiUrl) {
      window.location.replace(geminiUrl);
      return <></>;
    }

    return null;
  }
}
